import { styled } from "../../Theme";

export const VideoPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1em;
`;

export const SectionDescription = styled.div`
  display: flex;
  color: ${(props) => props.theme.color.text};
  width: 100%;
  justify-content: center;
  margin: 1em;
`;
